const style = ` 
.cashier-section-header {
  margin-left: 0px !important;
  margin-bottom: 10px !important;
  margin-top: 10px !important;
  border: 0px !important;
}

.list-has-radio.app_default .payment-method-header {
  height: 95px !important;
}

#cashier h5 {
  color: #5a5a5a!important;
}
#cashier .dropdown-toggler {
  // border: 1px solid;
  padding: 10px;
}

#cashier .list-payment-methods {
  padding: 10px 0px !important;
}
#cashier .main-header-container h3.payment-method-label {
  font-size: 15px!important;
  position: relative;
  top: -2px;
  font-weight: 600;
}
.CREDITCARD, .QLIRO {
  height: 40px !important;
}

.bambora-logo img {
  display: block;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: url(https://static.paymentiq.io/santander.svg) no-repeat;
  width: 100px; /* Width of new image */
  height: 20px; /* Height of new image */
  padding-left: 10px; /* Equal to width of new image */
  margin-left: -10px;
}

.global-submit-container {
  width: 100% !important;
}

.status .pending-container {
  margin-top: 0px !important;
}

.cashier-section-header {
  margin: var(--margin-size) 0px !important;
  padding-left: 12px !important;
}

@media (min-width: 767px) {
  .payment-method-details {
    padding: 10px 50px!important;
  }

  .cashier-section-header {
    margin: var(--margin-size) 0px !important;
    padding-left: 12px !important;
  }
  
  .payment-method-sub-label {
    font-size: 13px;
  }
}

#cashier .list-payment-methods .payment-method:hover {
  box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
}
#cashier .list-payment-methods .payment-method {
  transition: all .2s cubic-bezier(.25,.8,.25,1)!important;
  box-shadow: none;
  margin-bottom: 8px;
  border-radius: 7px;
  border: 1px solid #cfcfcf!important;
}
#cashier .payment-method.active {
  border-color: #a3a3a3!important;
}
#cashier .payment-method .payment-method-header {
  padding: 10px 15px!important;
  border-radius: 7px;
  background-color: #fff;
  border: none!important;
}
`
export default style
